import { useEffect, useState } from 'react';

import axios from 'axios';

import { DiveBar } from './Divebar';

const VERSION_POLL_TIME_MS = 300000;

const NewVersionMessage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasAlertBeenShown, setHasAlertBeenShown] = useState(false);
  const handleVersionNotificationClose = () => {
    setIsOpen(false);
    setHasAlertBeenShown(true);
  };

  useEffect(() => {
    const versionPollInterval = setInterval(async () => {
      const { data: manifestContentResponse } =
        await axios.get('/manifest.json');

      if (manifestContentResponse.version !== process.env.VITE_VERSION) {
        setIsOpen(true);
      }
    }, VERSION_POLL_TIME_MS);

    /** Uncomment this line to test a okta token refresh, this will run 10s after the page loads */
    // setTimeout(() => {
    //   oktaAuth.tokenManager.remove('idToken');
    // }, 10000);

    return () => {
      clearInterval(versionPollInterval);
    };
  }, []);

  return (
    <DiveBar
      open={isOpen && !hasAlertBeenShown}
      severity="success"
      handleClose={handleVersionNotificationClose}
      message="A new version of VideaAI is available, please refresh to receive these changes"
      action={{
        buttonName: 'Refresh Page',
        func: () => {
          window.location.reload();
        },
      }}
    />
  );
};

export const NewVersionPopup = (props: { isLoggedIn: any; user: any }) => {
  const { isLoggedIn } = props;
  if (!isLoggedIn) {
    return null;
  }
  return <NewVersionMessage />;
};
